import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import {ApiService} from "../../services/api.service";
import {User} from "../../interfaces/user";
import {AuthenticationService} from "../../services/auth.service";
import { ActivatedRoute, RouterLink } from "@angular/router";
import {NavigationBar, NavigationBarItem} from "../../interfaces/navigation";
import { DefaultFrameComponent } from '../../frames/default-frame/default-frame.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { KazAdsComponent } from '../../components/kaz-ads/kaz-ads.component';
import { KazMessagesComponent } from '../../components/kaz-messages/kaz-messages.component';
import { KazArchiveComponent } from '../../components/kaz-archive/kaz-archive.component';
import { SettingsComponent } from '../../components/settings/settings.component';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'kaz-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DefaultFrameComponent, RouterLink, FaIconComponent, KazAdsComponent, KazMessagesComponent, KazArchiveComponent, SettingsComponent, DatePipe]
})
export class ProfileComponent implements OnInit {
  private _api = inject(ApiService);
  private _route = inject(ActivatedRoute);
  private _auth = inject(AuthenticationService);

  profile: User | null = null;

  navBar: NavigationBar[] = [
    {name: "Anzeigen", value: NavigationBarItem.ENTRIES, current: true},
    {name: "Nachrichten", value: NavigationBarItem.MESSAGES, current: false},
    {name: "Archiv", value: NavigationBarItem.ARCHIVE, current: false},
    {name: "Einstellungen", value: NavigationBarItem.SETTINGS, current: false},
    // {name: 'FAVORITES', current: false},
  ];

  ngOnInit() {
    this.getOwnUser().then();
    this._route.params.subscribe(params => {
      const menu = params['menu'];
      this.setAsActive(menu ?? NavigationBarItem.ENTRIES);
    })
  }

  private async getOwnUser() {
    const userId = this._auth.getClaimsFromToken()?.id
    if (userId !== undefined)
      this.profile = await this._api.getOwnUser(userId);
  }

  getInitials() {
    if (this.profile !== null && this.profile !== undefined) {
      return this.profile.firstname[0] + this.profile.lastname[0];
    } else {
      return "--"
    }
  }

  setAsActive(navValue: NavigationBarItem) {
    for (const tab of this.navBar) {
      tab.current = tab.value === navValue;
    }
  }

  isActive(navValue: NavigationBarItem) {
    let nav = this.navBar.find(item => item.value === navValue)
    return nav !== undefined && nav.current;
  }

  protected readonly NavigationBarItem = NavigationBarItem;
}
